import { id, showError, axiosWrapper } from '@modernman00/shared-js-lib';
import axios from '@modernman00/shared-js-lib/axiosWrapper.js';

document.addEventListener('DOMContentLoaded', () => {
    const bubble = id('ai-chat-bubble');
    const chatWindow = id('chat-window');
    const input = id('chat-input-field');
    const sendBtn = id('send-btn');
    const messages = id('chat-messages');

    if (bubble) {
        bubble.addEventListener('click', () => {
            chatWindow.style.display = chatWindow.style.display === 'flex' ? 'none' : 'flex';
        });
    }

    const addMessage = (text, role) => {
        const div = document.createElement('div');
        div.className = `message ${role}`;
        div.innerText = text;
        messages.appendChild(div);
        messages.scrollTop = messages.scrollHeight;
    };

    const sendMessage = async () => {
        const query = input.value.trim();
        if (!query) return;

        addMessage(query, 'user');
        input.value = '';

        // Add loading state
        const loading = document.createElement('div');
        loading.className = 'message assistant';
        loading.innerText = 'Analyzing...';
        messages.appendChild(loading);

        try {
            const response = await axios.post('/api/chat', { query });
            const data = response.data;
            
            messages.removeChild(loading);
            addMessage(data.answer, 'assistant');
        } catch (error) {
            if (loading.parentNode) messages.removeChild(loading);
            showError(error);
            addMessage("Sorry, we're having trouble connecting right now.", 'assistant');
        }
    };

    if (sendBtn) {
        sendBtn.addEventListener('click', sendMessage);
    }

    if (input) {
        input.addEventListener('keypress', (e) => {
            if (e.key === 'Enter') sendMessage();
        });
    }
});
